// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { XngCarouselStyles } from "@synd/App/Components/XngCarousel";
import { coreSwiperShadow } from "@synd/App/Components/XngCarousel/styles/shared.styles";
import { color, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

/**
 * This file is intended for project use only
 */
export const syndCarouseStyles: XngCarouselStyles = {
    container: {
        css: css`
            ${({ direction, height }: any) => {
                if (direction === "vertical") {
                    return css`
                        .swiper-vertical {
                            display: flex;
                            flex-direction: column;
                        }
                        .swiper-wrapper {
                            height: 100% !important;
                            max-height: ${height ? `${height}px` : "100%"};
                        }
                        .swiper-slide {
                            &,
                            & > div {
                                width: 100%;
                            }
                        }
                    `;
                }
            }}
            .swiper-wrapper {
                box-sizing: border-box;
            }

            .xng-pagination-container {
                &:not(.visible) {
                    display: none;
                }
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 0;
                & > div {
                    margin: 0;
                }
                & > button {
                    margin: 0;
                    color: ${color("common.ui7")};
                    position: static;
                    background: transparent;
                    height: 18px;
                    width: 10px;
                    transform: none;
                    padding: 0px;
                    border: 0px;

                    & > ${IconWrapper} {
                        color: ${color("common.ui7")};
                        width: 10px;
                    }
                }
                & > .xng-carousel-prev {
                    margin-right: 12px;
                }

                & > .xng-carousel-next {
                    margin-left: 12px;
                }
            }

            .xng-pagination-container > .swiper-scrollbar.swiper-scrollbar-horizontal {
                height: 4px;
                width: 100%;
                margin-top: 12px;
                position: relative;
                top: unset;
                right: unset;
                bottom: unset;
                left: unset;
                transform: initial;
                display: flex;
                align-items: center;
                background: transparent;
                border-radius: 4px;
                & > .swiper-scrollbar-drag {
                    background: ${color("common.ui3")};
                    border-radius: 2px;
                    height: 4px;
                    cursor: pointer;
                }

                &.swiper-scrollbar-lock {
                    display: none;
                }
            }

            .swiper-horizontal > .xng-pagination-container {
                min-height: 10px;
                display: flex !important;
                gap: 4px;
            }

            ${({ slideMaxWidth }: any) => {
                if (slideMaxWidth) {
                    return css`
                        .swiper-slide {
                            max-width: ${slideMaxWidth};
                        }
                    `;
                }
            }}
            ${({ slideWidth }: any) => {
                if (slideWidth) {
                    return css`
                        .swiper-slide {
                            width: ${slideWidth} !important;
                        }
                    `;
                }
            }}

            .swiper-pagination {
                position: relative;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: start;
                flex-wrap: wrap;
                gap: 4px;
                padding-block: 0px;
                margin: 0 auto;
                max-width: fit-content;
                &.swiper-pagination-lock {
                    display: none;
                }
                .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    background: transparent;
                    border: 1px solid ${color("common.ui9")};
                    opacity: 1;
                    margin: 0 !important;
                    &:hover:not(.swiper-pagination-bullet-active) {
                        background: ${color("common.ui9")};
                        border-color: ${color("common.ui9")};
                    }
                    &.swiper-pagination-bullet-active {
                        background: ${color("common.ui11")};
                        border-color: transparent;
                        color: ${color("white")};
                    }
                }
            }
            ${xScreen("gte", "sm")} {
                ${coreSwiperShadow}
            }
        `,
    },
};
